import { useQuery } from '@tanstack/react-query';
import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';
import { CacheConfig } from './consts';

export const routes = {
  marketsPath: () => '/api/Markets',
  marketsLookupPath: (name) => (name === undefined ? '/api/Markets/Lookup' : `/api/Markets/Lookup?name=${name}`),
  marketsGridPath: () => '/api/Markets/Grid',
  marketPath: (id) => `/api/Markets/${id}`,
  mileageBandsPath: (id) => `/api/Markets/${id}/MileageBand`,
  mileageBandPostPath: () => '/api/Markets/MileageBand',
  mileageBandsAuditPath: (id, params) => `/api/Markets/${id}/MileageBands/Audits${getQueryParams(params)}`,
  mileageBandsAuditPropertiesPath: (id) => `/api/Markets/${id}/MileageBands/Audits/Properties`,
  mileageBandsAuditUsersPath: (id) => `/api/Markets/${id}/MileageBands/Audits/Users`,
  rateTypesPath: () => '/api/Markets/RateTypes',
  marketsAuditPath: (id) => `/api/Markets/${id}/Audits`,
  marketsAuditUsersPath: (id) => `/api/Markets/${id}/Audits/Users`,
  marketsAuditPropertiesPath: (id) => `/api/Markets/${id}/Audits/Properties`,
  marketsSearchPropertiesPath: () => '/api/Markets/SearchProperties',
  marketRestorePath: (id) => `/api/Markets/${id}/Restore`,
  marketTimeZonesPath: () => '/api/Markets/TimeZones',
};

export const getMarkets = () => makeRequest(authFetch.get(routes.marketsPath())).then((data) => data.map((c) => ({ ...c, value: c.id, name: c.abbreviation ?? '-' })));
export const useGetMarkets = () => useQuery(['markets'], getMarkets, CacheConfig.forever);

export const getMarketsLookup = () => makeRequest(authFetch.get(routes.marketsLookupPath()));
export const useGetMarketsLookup = () => useQuery(['marketsLookup'], getMarketsLookup, CacheConfig.forever);

export const searchMarketsLookup = (name) => makeRequest(authFetch.get(routes.marketsLookupPath(name)));

export const getMarketsGrid = (params) => makeRequest(authFetch.get(`${routes.marketsGridPath()}${getQueryParams(params)}`));

export const getMarket = (id) => makeRequest(authFetch.get(routes.marketPath(id)));

export const putMarket = (data) => makeRequest(authFetch.put(routes.marketsPath(), data));

export const getMileageBand = (id) => makeRequest(authFetch.get(routes.mileageBandsPath(id)));

export const postMileageBand = (data) => makeRequest(authFetch.post(routes.mileageBandPostPath(), data));

export const getMileageBandsAudit = (id, params) => makeRequest(authFetch.get(routes.mileageBandsAuditPath(id, params)));

export const getMileageBandsAuditProperties = (id) => makeRequest(authFetch.get(routes.mileageBandsAuditPropertiesPath(id)));

export const getMileageBandsAuditUsers = (id) => makeRequest(authFetch.get(routes.mileageBandsAuditUsersPath(id)));

export const getMarketRateTypes = () => makeRequest(authFetch.get(routes.rateTypesPath()));

export const getLocationAudits = async (id, params) => makeRequest(authFetch.get(`/api/Locations/${id}/Audits${getQueryParams(params)}`));

export const getLocationAuditProperties = async (id) => makeRequest(authFetch.get(`/api/Locations/${id}/Audits/Properties`));

export const getLocationAuditUsers = async (id) => makeRequest(authFetch.get(`/api/Locations/${id}/Audits/Users`));

export const exportMileageBands = (id) => makeRequest(authFetch.get(`/api/Markets/${id}/MileageBands/Export`));
export const uploadMileageBands = (id, data) => makeRequest(authFetch.put(`/api/Markets/${id}/MileageBands`, data));
export const previewMileageBands = (id, data) => makeRequest(authFetch.post(`/api/Markets/${id}/MileageBands/Preview`, data));

export const getMarketTimeZones = () => makeRequest(authFetch.get(routes.marketTimeZonesPath()));

export const getMarketsAudits = async (id, params) => makeRequest(authFetch.get(`${routes.marketsAuditPath(id)}${getQueryParams(params)}`));
export const getMarketsAuditProperties = async (id) => makeRequest(authFetch.get(`${routes.marketsAuditPropertiesPath(id)}`));
export const getMarketsAuditUsers = async (id) => makeRequest(authFetch.get(`${routes.marketsAuditUsersPath(id)}`));
export const getMarketsSearchProperties = () => makeRequest(authFetch.get(routes.marketsSearchPropertiesPath()));
export const restoreMarket = (id) => makeRequest(authFetch.patch(routes.marketRestorePath(id)));
export const deleteMarket = (id) => makeRequest(authFetch.delete(routes.marketPath(id)));
